import type React from 'react';
import { Button } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  translateId?: string;
  disabled?: boolean;
  timeLeftFormatted?: string;
};

const ButtonElement = styled(Button)<Props>`
  && {
    border: 1px solid ${({ theme }) => theme.color.beerus[100]};
    height: ${rem(56)};
    padding: ${rem(12)};
    border-radius: ${rem(12)};
    div {
      grid-template-columns: auto 3fr auto;
      items: center;
      span {
        text-align: center;
        font-weight: ${({ disabled }) => (disabled ? '400' : '600')}};
        font-size: ${rem(16)};
      }
      svg {
        width: ${rem(32)};
        height: ${rem(32)};
      }
    }
  }
`;

const OptionsButton: FC<Props> = ({
  children,
  onClick,
  translateId,
  disabled,
  timeLeftFormatted,
}) => (
  <ButtonElement iconLeft fullWidth onClick={onClick} disabled={disabled}>
    {children}
    <Translate id={translateId as string} />
    {disabled && timeLeftFormatted}
  </ButtonElement>
);

export default OptionsButton;
